export enum PageTypes {
  Profile = "profile",
  Team = "team",
  Project = "project",
  Event = "event",
  FinishedEvent = "finishedEvent",
  Topics = "topics",
}

export const genPageName = (type: PageTypes) => {
  let name = "";

  switch (type) {
    case PageTypes.Profile:
      name = "プロフィール";
      break;
    case PageTypes.Team:
      name = "チーム";
      break;
    case PageTypes.Project:
      name = "プロジェクト";
      break;
    case PageTypes.Event:
      name = "イベント";
      break;
    case PageTypes.FinishedEvent:
      name = "終了したイベント";
      break;
    case PageTypes.Topics:
      name = "トピックス";
      break;
    default:
      break;
  }

  return name;
};
